import React, { useState } from 'react';

const NoteWidget = ({ config }) => {
    const { settings = {} } = config;
    const [text, setText] = useState(settings.text || '');

    return (
        <div className="note-widget">
            <textarea
                className="note-widget__textarea"
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="Add a note for your team…"
            />
        </div>
    );
};

export default NoteWidget;
